import * as anchor from "@project-serum/anchor";
import axios from "axios";
import idl from "./idl.json";

// import { getMetadata } from "/home/raaedk/metaplex-foundation/metaplex/js/packages/common/src/actions/metadata"

import { Metadata } from "@metaplex/js";

export const MONSTER_PROGRAM = new anchor.web3.PublicKey(
  "46y4jYjP7zQR3uESNMGTAtFp3B3Ew7ED32Ec3VysqxmE"
);

export const METADATA_PROGRAM = new anchor.web3.PublicKey(
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);

export interface Ability {
  att: number;
  bump: number;
  monster: anchor.web3.PublicKey;
  moveSlot: number;
  name: string;
}

export interface BattleState {
  battleState: number;
  player1: anchor.web3.PublicKey;
  player2: anchor.web3.PublicKey;
  monster1: anchor.web3.PublicKey;
  monster2: anchor.web3.PublicKey;
  monster1Health: number;
  monster2Health: number;
  monster1Mana: number;
  mosnter2Mana: number;
}

export interface MetadataType {
  attributes: any[];
  collection: object;
  description: string;
  external_url: string;
  image: string;
  name: string;
  properties: object;
  seller_fee_basis_points: number;
  symbol: string;
}

export interface Monster {
  name: string;
  uri: string;
  maxHp: number;
  maxMana: number;
  level: number;
  attack: number;
  defense: number;
  authority: anchor.web3.PublicKey;
}

export const getFightState = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  battleId: anchor.web3.PublicKey
) => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  var state: any;

  try {
    const program = new anchor.Program(
      idl as anchor.Idl,
      MONSTER_PROGRAM,
      provider
    );
    state = await program.account.battle.fetch(battleId);
  } catch (err) {
    console.log(err);
  }

  return state;
};

export const getOwnedMetadata = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection
): Promise<Metadata[]> => {
  let list = await Metadata.findByOwnerV2(connection, anchorWallet.publicKey);
  console.log(list);
  return list;
};

export const createMonster = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection
): Promise<Monster> => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  let [monsterPDA, bump] = await getMonsterPDA(anchorWallet, connection);

  // const TEST_NFT_MINT = new anchor.web3.PublicKey("GGQgUdDj8sqi9vKMmkqJkSNoxZDqDg54uY8LvoAcjTnV")
  // const NFT_MINT = new anchor.web3.PublicKey("4D5byPNkS6JBQo1fHkqWnnRVnyykTctrFEkRDeL5EpYF")

  // let metadata = await Metadata.getPDA(NFT_MINT);

  // console.log("metadata address")
  // console.log(metadata.toString())

  let test = await Metadata.findByOwnerV2(connection, anchorWallet.publicKey);

  let nftMetadata: Metadata = test[0];

  console.log(nftMetadata.pubkey.toString());

  console.log(monsterPDA);

  // console.log('pda')
  // console.log((await Metadata.getPDA(nft.data.mint)).toString())

  await program.rpc.createMonster(bump, {
    accounts: {
      monster: monsterPDA,
      authority: provider.wallet.publicKey,
      systemProgram: anchor.web3.SystemProgram.programId,
      metadata: nftMetadata.pubkey,
    },
  });

  return getMonster(anchorWallet, connection, monsterPDA);
};

export const getMonsterFromWallet = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection
) => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  let [monsterPDA] = await getMonsterPDA(anchorWallet, connection);

  var state: any;

  try {
    state = await program.account.monster.fetch(monsterPDA);
    const response = await axios.get(state.uri);
    console.log(response);
  } catch (err) {
    console.log(err);
  }

  return state;
};

export const getMonster = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  monsterId: anchor.web3.PublicKey
): Promise<Monster> => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  var state: any;

  // console.log(monsterId);

  try {
    const program = new anchor.Program(
      idl as anchor.Idl,
      MONSTER_PROGRAM,
      provider
    );

    state = await program.account.monster.fetch(monsterId);
    console.log(state);

    const response = await axios.get(state.uri);
    console.log(response);
  } catch (err) {
    console.log(err);
  }

  return state;
};

export const getMonsterProgram = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection
) => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  return program;
};

export const getProviderAndProgram = async () => {};

export const getMonsterPDA = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection
): Promise<[anchor.web3.PublicKey, number]> => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  return anchor.web3.PublicKey.findProgramAddress(
    [Buffer.from("monster"), anchorWallet.publicKey.toBuffer()],
    program.programId
  );
};

export const createMonsterFight = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection
): Promise<anchor.web3.PublicKey> => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  const [pda] = await getMonsterPDA(anchorWallet, connection);

  var battlekey = anchor.web3.Keypair.generate();

  await program.rpc.initializeBattle({
    accounts: {
      battle: battlekey.publicKey,
      authority: anchorWallet.publicKey,
      monster: pda,
      systemProgram: anchor.web3.SystemProgram.programId,
    },
    signers: [battlekey],
  });

  return battlekey.publicKey;
};

export const joinMonsterFight = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  battleId: anchor.web3.PublicKey
) => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  const [pda] = await getMonsterPDA(anchorWallet, connection);

  console.log(pda);

  await program.rpc.joinBattle({
    accounts: {
      battle: battleId,
      monster: pda,
      authority: anchorWallet.publicKey,
    },
  });
};

export const useMonsterAbility = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  monsterAddress: anchor.web3.PublicKey,
  moveSlot: number,
  attackedAddress: anchor.web3.PublicKey,
  battle: anchor.web3.PublicKey,
  playerNum: number
) => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  let [abilityPda, bump] = await anchor.web3.PublicKey.findProgramAddress(
    [
      Buffer.from("attack"),
      monsterAddress.toBuffer(),
      new anchor.BN(moveSlot).toArrayLike(Buffer, "le", 1),
    ],
    program.programId
  );

  await program.rpc.useAbility(playerNum, moveSlot, bump, {
    accounts: {
      monster: monsterAddress,
      battle: battle,
      ability: abilityPda,
      attackedMonster: attackedAddress,
      authority: anchorWallet.publicKey,
    },
  });
};

export const getAbilityPDA = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  monsterAdress: anchor.web3.PublicKey,
  moveSlot: number
): Promise<[anchor.web3.PublicKey, number]> => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  return anchor.web3.PublicKey.findProgramAddress(
    [
      Buffer.from("attack"),
      monsterAdress.toBuffer(),
      new anchor.BN(moveSlot).toArrayLike(Buffer, "le", 1),
    ],
    program.programId
  );
};

export const teachMonsterAbility = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  moveSlot: number,
  moveId: number
) => {
  const provider = new anchor.Provider(connection, anchorWallet, {
    preflightCommitment: "recent",
  });

  const program = new anchor.Program(
    idl as anchor.Idl,
    MONSTER_PROGRAM,
    provider
  );

  const [monsterPda] = await getMonsterPDA(anchorWallet, connection);
  const [abilityPda, bump] = await getAbilityPDA(
    anchorWallet,
    connection,
    monsterPda,
    moveSlot
  );

  await program.rpc.teachMove(moveId, moveSlot, bump, {
    accounts: {
      monster: monsterPda,
      authority: anchorWallet.publicKey,
      ability: abilityPda,
      systemProgram: anchor.web3.SystemProgram.programId,
    },
  });
};

export const fetchOtherMonsterAbility = async (
  anchorWallet: anchor.Wallet,
  monsterAddress: anchor.web3.PublicKey,
  connection: anchor.web3.Connection,
  moveSlot: number
) => {
  let ability: any;

  try {
    const provider = new anchor.Provider(connection, anchorWallet, {
      preflightCommitment: "recent",
    });

    const program = new anchor.Program(
      idl as anchor.Idl,
      MONSTER_PROGRAM,
      provider
    );

    let [abilityPda] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("attack"),
        monsterAddress.toBuffer(),
        new anchor.BN(moveSlot).toArrayLike(Buffer, "le", 1),
      ],
      program.programId
    );

    ability = await program.account.ability.fetch(abilityPda);

    return ability;
  } catch (err) {
    console.log(err);
  }
};

export const fetchMonsterAbility = async (
  anchorWallet: anchor.Wallet,
  connection: anchor.web3.Connection,
  moveSlot: number
) => {
  let ability: any;

  try {
    const provider = new anchor.Provider(connection, anchorWallet, {
      preflightCommitment: "recent",
    });

    const program = new anchor.Program(
      idl as anchor.Idl,
      MONSTER_PROGRAM,
      provider
    );
    const [monsterAddress] = await getMonsterPDA(anchorWallet, connection);

    let [abilityPda] = await anchor.web3.PublicKey.findProgramAddress(
      [
        Buffer.from("attack"),
        monsterAddress.toBuffer(),
        new anchor.BN(moveSlot).toArrayLike(Buffer, "le", 1),
      ],
      program.programId
    );

    ability = await program.account.ability.fetch(abilityPda);

    return ability;
  } catch (err) {
    console.log(err);
  }
};
